import { FC } from "react";

import { Flex, Typography } from "antd";

import { COLORS } from "../../../../../config/themes/colors";

import './index.css'

export interface CustomLegendProps {
    color?:     string;
    label?:     string;
}

export const CustomLegend: FC<CustomLegendProps> = ({ color = COLORS.primary[50], label = "" }) =>  (
    <Flex className="chart-legend-container">
        <div 
            style={{ backgroundColor: color }}
            className="chart-legend-box-color"
        />
        <Typography.Text type="secondary"> { label } </Typography.Text>
    </Flex>
)
